import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { exportMemberEventLogCsv } from '../../services'
import { ExportMemberEventLogCsvRequest } from '@/modules/manage-member/type'
import { downloadFile } from '@/common/utils/downloadFile'
import { OperatorMutationKeys } from '@/modules/manage-member/keys'

export default function useMutationExportEventLogCsv() {
	return useMutation({
		mutationKey: [OperatorMutationKeys.ExportEventLogCsv],
		mutationFn: (payload: ExportMemberEventLogCsvRequest) =>
			exportMemberEventLogCsv(payload),
		onSuccess: (blob, variables) => {
			downloadFile({
				blob,
				defaultFilename: variables.filename || 'operator_event_log',
			})
			toast.success('ดาวน์โหลดไฟล์ CSV สำเร็จ')
		},
		onError: () => {
			toast.error('การดาวน์โหลดไฟล์ CSV ล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
